import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Lock, Sparkles } from "lucide-react";

interface UpgradeProDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  styleName?: string;
  context?: "style" | "variation";
}

export const UpgradeProDialog = ({
  open,
  onOpenChange,
  styleName,
  context = "style",
}: UpgradeProDialogProps) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    onOpenChange(false);
    navigate("/pricing");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            <Lock className="h-6 w-6 text-primary" />
          </div>
          <DialogTitle className="text-center">
            {context === "variation"
              ? "Unlock multiple variations"
              : styleName
                ? `"${styleName}" is a Pro style`
                : "Unlock Pro styles"}
          </DialogTitle>
          <DialogDescription className="text-center">
            {context === "variation"
              ? "Buy a one-time credit pack to generate 2 or 3 design variations at once."
              : "Buy a one-time credit pack to unlock the full library of premium design styles across every category."}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-2 sm:flex-col">
          <Button onClick={handleUpgrade} className="w-full">
            <Sparkles className="mr-2 h-4 w-4" />
            See credit packs
          </Button>
          <Button
            variant="ghost"
            onClick={() => onOpenChange(false)}
            className="w-full"
          >
            Maybe later
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
